module.exports = __webpack_public_path__ + "media/7_BL.fa99c005.mp3";